import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AppStore } from '../app.store'

export const vehicleTrackingGuard: CanActivateFn = (route, state) => {
    const router = inject(Router)
    const quartixGroupId = inject(AppStore).companySettings().quartixGroupId ?? 0

    if (quartixGroupId > 0) {
        return true
    }

    router.navigateByUrl('/admin/vehicle-tracking')
    return false
}
